// extracted by mini-css-extract-plugin
export default {"container":"Controls_container__Hdr1r","next":"Controls_next__DbhAz"};